/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TextWeight {
  Regular = 'Regular',
  Semibold = 'Semibold',
  Bold = 'Bold'
}
